import { render, staticRenderFns } from "./StanleyTyping.vue?vue&type=template&id=2f490910&scoped=true"
import script from "./StanleyTyping.vue?vue&type=script&lang=js"
export * from "./StanleyTyping.vue?vue&type=script&lang=js"
import style0 from "./StanleyTyping.vue?vue&type=style&index=0&id=2f490910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f490910",
  null
  
)

export default component.exports